import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import web5 from "../img/patho.jpg";
import h1 from "../img/p1.jpg";
import h2 from "../img/p2.jpg";
import h3 from "../img/p3.jpg";
import h4 from "../img/p4.jpg";
import h5 from "../img/settings.jpg";
import h6 from "../img/expr.jpg";

import "../style/styles.css";
import "../style/Pathology.css";

const Pathology = () => {
  let alText = "Photo PathoLogy";

  const quickStats = [
    { value: "Patient", label: "Registration & Billing" },
    { value: "Lab", label: "Report Management" },
    { value: "Test", label: "Packages" },
    { value: "Online", label: "Report Transfer" },
  ];

  const featureCards = [
    {
      title: "Patients Registration & Billing",
      image: h1,
      text:
        "Easy patient registration allows seamless bill management and electronic records of patients, dues, discounts, and payment history centrally. Add new lab cases to existing patient record, download reports in MS-Excel, and manage rates from a single page",
    },
    {
      title: "Lab Report Management",
      image: h2,
      text:
        "We're standing by to answer  all queries and training support as on require 24 x 7 , after all the Quality counts on after sales support we are committed for support to our clients. The digital support our help desk is always ready to ans.",
    },
    {
      title: "Customized Test Packages",
      image: h3,
      text:
        "Software gives feature of easy handling of software with customization facility, labs can prepare own letter pad logo address contact numbers in single click the feature is inbuilt in the Software. The facility to take print bills and reports on letter pad and on plane paper also.",
    },
    {
      title: "Operations & Report Activity Tracking",
      image: h4,
      text:
        "Easy patient registration allows seamless bill management and electronic records of patients, dues, discounts, and payment history centrally. Add new lab cases to existing patient record, download reports in MS-Excel, and manage rates from a single page",
    },
    {
      title: "User Management",
      image: h5,
      text:
        "Software comes with exclusive Security feature. The user id & password management system with admin control facility is available in the Software. We advise admin to update with security management on regular intervals.Add more than one user access and configure permissions for each user to ensure accountability and lab data security. Provide separate permissions for lab incharge and receptionist,billing etc.",
    },
    {
      title: "Reports Transfer Online",
      image: h6,
      text:
        "Send reports via email, WhatsApp, and SMS, anytime, anywhere.",
    },
  ];

  const labDepartments = [
    "Haematology",
    "Biochemistry",
    "Serology & Immunology",
    "Clinical pathology",
    "Microbiology",
    "Endocrinology",
    "Histopathology",
    "Cytology",
  ];

  const detailsFeatures = [
    "Patient Registration and Billing",
    "Sample Collection Management",
    "Pathology Reports Management",
    "Patient Registration and Billing",
    "Sample Collection Management",
    "Pathology Reports Management",
  ];

  const keyModules = [
    {
      title: "Patient Registration & Billing",
      text:
        "Easy patient registration with bill management, dues, discounts, payment history, existing patient records and MS-Excel report download support.",
    },
    {
      title: "Lab Report Management",
      text:
        "Lab report management with training support, customer help desk support and quality-focused after sales support.",
    },
    {
      title: "Customized Test Packages",
      text:
        "Configure lab letter pad, logo, address, contact numbers and test package printing on letter pad or plain paper.",
    },
    {
      title: "Report Activity Tracking",
      text:
        "Track operations and report activity with centralized patient records, new lab cases, rates and billing workflow.",
    },
    {
      title: "User Management",
      text:
        "Admin controlled user ID and password management with user-wise permissions for lab incharge, receptionist, billing and other users.",
    },
    {
      title: "Online Report Transfer",
      text:
        "Send reports via email, WhatsApp and SMS anytime, anywhere.",
    },
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="pathology-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          PathoSof - Pathology Lab Report, Billing & Diagnostic Software | EBS Software Solution
        </title>
        <meta
          name="description"
          content="PathoSof is pathology and diagnostic lab software for patient registration, billing, lab report management, customized test packages, activity tracking, user management and online report transfer through email, WhatsApp and SMS."
        />
      </Helmet>

      <section className="pathology-hero">
        <img
          className="pathology-hero-bg"
          src={web5}
          alt={alText}
          onError={handleImageError}
        />
        <div className="pathology-hero-overlay"></div>

        <Container className="pathology-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="pathology-hero-content">
                <div className="pathology-kicker">Pathology & Diagnostic Software</div>
                <h1>PathoSof</h1>
                <h2>
                  Pathology Lab Report, Billing and Diagnostic Management Software
                </h2>
                <p>
                  PathoSof helps labs manage patient registration, billing,
                  customized test packages, lab report management, report
                  activity tracking, user security and online report transfer
                  from one organized diagnostic software platform.
                </p>

                <div className="pathology-hero-actions">
                  <a href="#pathology-modules" className="pathology-btn pathology-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="pathology-btn pathology-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="pathology-highlight-card">
                <span>Diagnostic Lab Solution</span>
                <strong>Registration + Billing + Reports + Online Transfer</strong>
                <p>
                  Built for pathology labs and diagnostic centres to manage
                  patients, tests, reports, security and communication.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pathology-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="pathology-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="pathology-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="pathology-section-label">Overview</div>
              <h2 className="pathology-section-title">
                Simple and professional pathology lab management
              </h2>
              <p className="pathology-text">
                PathoSof supports easy patient registration, seamless bill
                management and electronic records of patients, dues, discounts
                and payment history centrally.
              </p>
              <p className="pathology-text">
                The software helps add new lab cases to existing patient
                records, download reports in MS-Excel, manage rates from a
                single page and transfer reports online through email, WhatsApp
                and SMS.
              </p>
            </Col>

            <Col lg={6}>
              <div className="pathology-overview-card">
                <h3>PathoSof covers</h3>
                <div className="pathology-overview-grid">
                  <div><span>✓</span><p>Patient Registration</p></div>
                  <div><span>✓</span><p>Billing</p></div>
                  <div><span>✓</span><p>Lab Reports</p></div>
                  <div><span>✓</span><p>Test Packages</p></div>
                  <div><span>✓</span><p>User Security</p></div>
                  <div><span>✓</span><p>Online Transfer</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pathology-modules-section" id="pathology-modules">
        <Container>
          <div className="pathology-heading-center">
            <div className="pathology-section-label">Key Modules</div>
            <h2 className="pathology-section-title">
              Complete lab workflow from patient registration to report transfer
            </h2>
            <p>
              PathoSof connects patient registration, billing, test packages,
              report management, security and online delivery into one
              professional pathology software.
            </p>
          </div>

          <Row className="g-4">
            {keyModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="pathology-module-card">
                  <div className="pathology-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="pathology-feature-card-section">
        <Container>
          <Row className="g-4">
            {featureCards.map((feature) => (
              <Col lg={4} md={6} key={feature.title}>
                <div className="pathology-image-feature-card">
                  <div className="pathology-image-wrap">
                    <img
                      src={feature.image}
                      alt={feature.title}
                      onError={handleImageError}
                    />
                  </div>
                  <div className="pathology-image-card-body">
                    <h3>{feature.title}</h3>
                    <p>{feature.text}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="pathology-lab-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="pathology-lab-title">
                <div className="pathology-section-label">Departments</div>
                <h2 className="pathology-section-title">
                  Pathology department coverage
                </h2>
                <p>
                  PathoSof supports common pathology and diagnostic departments
                  for practical lab reporting and daily operations.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="pathology-lab-grid">
                {labDepartments.map((item) => (
                  <div key={item}>
                    <span>✓</span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pathology-details-section">
        <Container>
          <div className="pathology-details-card">
            <div className="pathology-section-label">PathoSof Details Features</div>
            <h2>PathoSof Details Features</h2>
            <Row className="g-3">
              {detailsFeatures.map((item, index) => (
                <Col lg={4} md={6} key={`${item}-${index}`}>
                  <div className="pathology-details-item">
                    <span>✓</span>
                    <p>{item}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>

      <section className="pathology-cta-section">
        <Container>
          <div className="pathology-cta-card">
            <div>
              <span>Ready to manage your diagnostic lab professionally?</span>
              <h2>Use PathoSof for patient billing, reports and online delivery.</h2>
              <p>
                Get a pathology management solution with patient registration,
                billing, test packages, report activity tracking, user
                management and report transfer through email, WhatsApp and SMS.
              </p>
            </div>
            <Link to="/EmailContactForm" className="pathology-btn pathology-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Pathology;
